import { Filter, FilterOption } from '~/core/models';
import {
  FilterInput,
  Option,
  SelectedFilterOptions,
  TypeOfFilter,
} from '~/core/types/sortAndFilter';

export const convertFiltersModelToUI = (input: FilterInput): TypeOfFilter[] =>
  Object.entries(input).map(([key, category], index): TypeOfFilter => {
    const options: Option[] = category.filterOptions.map((option) => ({
      label: option.name,
      qty: option.numberOfItems,
    }));

    return [key, options, index];
  });

export const convertFiltersUIToModel = (
  array: TypeOfFilter[],
  selectedFilters: SelectedFilterOptions
): FilterInput =>
  array.reduce<FilterInput>((acc, [categoryName, options]) => {
    const filterOptions: FilterOption[] = options.map((option) => {
      const isSelected =
        selectedFilters[categoryName]?.includes(option.label) ?? false;

      return {
        name: option.label,
        numberOfItems: option.qty,
        isSelected,
      };
    });

    acc[categoryName] = {
      filterOptions,
      isExpanded: false,
    };

    return acc;
  }, {});

export const transformSelectedFiltersRecordToRecord = (
  filters: FilterInput
): Record<string, Filter> => {
  // This will hold the selected filters as a Record
  const filtersRecord: Record<string, Filter> = {};

  // Transform selected filters from one record to another
  for (const key of Object.keys(filters)) {
    const currentFilters = filters[key];

    if (currentFilters) {
      filtersRecord[key] = currentFilters;
    }
  }

  return filtersRecord;
};
